module.exports = "#btnChange\r\n{\r\n    margin:5px 5px;\r\n    width: 85px;\r\n}\r\n\r\n.rightcard-body{\r\n    border:1px solid #8C8C8C;\r\n    border-top-style: none; \r\n}\r\n\r\n.greycolor {\r\n    color: #999999;\r\n}\r\n\r\n.whitecolor\r\n{\r\n    color: #FFFFFF;  \r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shoppingcart/checkout/checkout.component.css
// module id = ./src/app/shoppingcart/checkout/checkout.component.css
// module chunks = main